export default __webpack_public_path__ + "static/media/copy.6201564a.svg";